import utility from '@/mixins/utility'

import _ from 'lodash'
import moment from 'moment'

class User {

  #data = {}

  #groups = []

  constructor(collection={})
  {
    this.#data = collection

    if( collection.groups )
      this.#groups = utility.methods.mapModels(collection.groups, 'group')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active == true
  }

  get email()
  {
    return this.#data.email
  }

  get emailVerifiedAt()
  {
    let value = this.#data.email_verified_at

    return value ? moment(value) : null
  }

  get firstname()
  {
    return this.#data.firstname
  }

  get id()
  {
    return this.#data.id
  }

  get lastname()
  {
    return this.#data.lastname
  }

  get token()
  {
    return this.#data.token
  }

  get crisp()
  {
    return this.#data.crisp
  }

  /**
   * Computed properties.
   */
  
  get fullname()
  {
    const fullname = _.chain([ this.firstname, this.lastname ])
                        .filter()
                        .join(' ')
                        .value()

    return fullname
  }

  get hasGroup()
  {
    return this.groups.length > 0
  }

  get hasManyGroups()
  {
    return this.groups.length > 1
  }

  get initials()
  {
    let initials = _.chain(this.fullname)
                    .split(' ')
                    .map((el)=>el.substring(0,1))
                    .join('')
                    .value()
    return initials
  }

  /**
   * Relationships.
   */
  
  get groups()
  {
    return this.#groups
  }


  /**
   * Methods.
   */
  
  

}

export default User